const KEYS = { LANG: 'ludus-lang', THEME: 'ludus-theme' };

function safeGet(key) {
  try { return localStorage.getItem(key); } catch { return null; }
}
function safeSet(key, val) {
  try { val == null ? localStorage.removeItem(key) : localStorage.setItem(key, val); } catch {}
}

export const getStoredLang  = () => safeGet(KEYS.LANG);
export const setStoredLang  = (v) => safeSet(KEYS.LANG, v);
export const getStoredTheme = () => safeGet(KEYS.THEME);
export const setStoredTheme = (v) => safeSet(KEYS.THEME, v);
